import { render, staticRenderFns } from "./IbxChipList.vue?vue&type=template&id=70f7d73b"
import script from "./IbxChipList.vue?vue&type=script&lang=js"
export * from "./IbxChipList.vue?vue&type=script&lang=js"
import style0 from "./IbxChipList.vue?vue&type=style&index=0&id=70f7d73b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports